import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import plateBg from '../../assets/images/plate_classic_square_bg.png';

const StyledContainer = styled.div`
	position: relative;
	width: 200px;
	height: 140px;
	background-color: #f4f4f4;
	border-radius: 10px;
	background-image: url(${plateBg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
`;

const StyledStroke = styled.div`
	position: absolute;
	top: 2px;
	left: 2px;
	bottom: 2px;
	right: 2px;
	opacity: 0.5;
	border: 1px solid #000000;
	border-radius: 9px;
`;

const StyledBgLine = styled.div`
	position: absolute;
	right: 3px;
	bottom: 3px;
	width: 90px;
	height: 67px;
	opacity: 0.5;
	border-width: 1px 0px 0px 1px;
	border-style: solid;
	border-color: #000000;
	border-radius: 10px 0px 8px;
`;

const StyledLetter = styled(Text)`
	width: 22px;
	font-weight: 500;
	font-size: 50px;
	line-height: 57px;
	color: #000000;
	text-shadow:
		-2px -2px 0px rgba(255, 255, 255, 0.75),
		2px 2px 0px rgba(0, 0, 0, 0.1);
`;

const StyledDigit = styled(Text)`
	width: 26px;
	font-weight: 500;
	font-size: 50px;
	line-height: 57px;
	color: #000000;
	text-shadow:
		-2px -2px 0px rgba(255, 255, 255, 0.75),
		2px 2px 0px rgba(0, 0, 0, 0.1);
`;

const StyledSymbols = styled(Text)`
	font-weight: 500;
	font-size: 50px;
	line-height: 57px;
	color: #000000;
	text-shadow:
		-2px -2px 0px rgba(255, 255, 255, 0.75),
		2px 2px 0px rgba(0, 0, 0, 0.1);
	white-space: pre;
`;

const StyledTopLetter = styled(StyledSymbols)`
	position: absolute;
	left: 26px;
	top: 10px;
`;

const StyledBottomLetters = styled(StyledSymbols)`
	position: absolute;
	width: 80px;
	display: flex;
	justify-content: center;
	left: 16px;
	bottom: 8px;
`;

const StyledDigits = styled(StyledSymbols)`
	position: absolute;
	left: 77px;
	top: 10px;
`;

const StyledSlot = styled(StyledSymbols)<{ $letter?: string }>`
	display: inline-block;
	width: ${(props) => {
		const letter = props.$letter?.toLowerCase();
		if (letter === 'м' || letter === 'm') return '40px';
		if (letter === 'о' || letter === 'o') return '40px';
		if (letter === 'с' || letter === 'c') return '40px';
		return '30px';
	}};
	text-align: center;
`;

const StyledNumberContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 27px;
	transform: translateY(-50%);
	display: flex;
	align-items: flex-end;
	justify-content: center;
`;

const StyledCountryContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 5px;

	${Text} {
		font-weight: 300;
		font-size: 14px;
		line-height: 16px;
		color: #000000;
		text-shadow:
			-1px -1px 0px rgba(255, 255, 255, 0.75),
			1px 1px 0px rgba(0, 0, 0, 0.1);
	}

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledRegionContainer = styled.div`
	position: absolute;
	bottom: 17px;
	right: 27px;
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 10px;
`;

const StyledRegion = styled(Text)`
	width: 38px;
	height: 14px;
	font-weight: 700;
	font-size: 20px;
	line-height: 23px;
	color: #000000;
	text-shadow:
		-1px -1px 0px rgba(255, 255, 255, 0.75),
		1px 1px 0px rgba(0, 0, 0, 0.1);
	text-align: center;
`;

export {
	StyledBgLine,
	StyledBottomLetters,
	StyledContainer,
	StyledCountryContainer,
	StyledDigit,
	StyledDigits,
	StyledLetter,
	StyledNumberContainer,
	StyledRegion,
	StyledRegionContainer,
	StyledSlot,
	StyledStroke,
	StyledTopLetter,
};
